import Skeleton from "@/components/ui/skeleton";

export default function Loading() {
  return (
    <div className="p-6 w-full">
      <div className="flex flex-col gap-6 max-w-5xl mx-auto">
        <Skeleton className="h-8 w-1/2" />
        <Skeleton className="h-12 w-full rounded-2xl" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Skeleton className="h-48 w-full rounded-2xl" />
          <Skeleton className="h-48 w-full rounded-2xl" />
        </div>
      </div>
    </div>
  );
}
